export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const PROFILE_PICTURE_INSURANCE_ID_REQUEST = 'PROFILE_PICTURE_INSURANCE_ID_REQUEST';
export const PROFILE_PICTURE_INSURANCE_ID_SUCCESS = 'PROFILE_PICTURE_INSURANCE_ID_SUCCESS';
export const PROFILE_PICTURE_INSURANCE_ID_FAILURE = 'PROFILE_PICTURE_INSURANCE_ID_FAILURE';
